import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as InstitutionProgramFeatureState from './institution-program.state';

export const selectInstitutionProgramState =
  createFeatureSelector<InstitutionProgramFeatureState.InstitutionProgramState>(
    InstitutionProgramFeatureState.institutionProgramFeatureKey
  );

export const selectInstitutionPrograms = createSelector(
  selectInstitutionProgramState,
  InstitutionProgramFeatureState.selectAll
);

export const selectProgramsForInstitutionOptions = createSelector(
  selectInstitutionProgramState,
  (state) => state.programsForInstitutionOptions
);
